import replaceQuery from 'vue-replace-query-mixin'

import {
  apiCheckAuth,
  apiLogin,
  apiGetUser,
  apiLogout,
} from '@/functions/api'

import {
  languageCode,
} from '@/mixins/languageCode'

export const isAuthReady = {
  computed: {
    isAuthReady() {
      return this.$store.state.auth.auth_checked
    }
  }
}

export const isAuthorized = {
  computed: {
    isAuthorized() {
      return this.$store.state.auth.id_fetched
    },
  },
}

export const authUser = {
  computed: {
    isUserFetched() {
      return this.$store.state.auth.user_fetched
    },
    authUser() {
      return this.isUserFetched && this.$store.state.auth.user
    },
  },
}

export const checkAuth = {
  mixins: [
    isAuthorized,
  ],
  methods: {
    async checkAuth() {
      if (this.isAuthorized) {
        return {ok: true}
      }
      const result = await apiCheckAuth()

      await this.$store.dispatch('auth/checkAuth')

      if (result.ok) {
        const {id} = result.result
        await this.$store.dispatch('auth/login', id)
      }

      return result
    }
  }
}

export const removeAuthDataFromQuery = {
  mixins: [
    replaceQuery,
  ],
  methods: {
    removeAuthDataFromQuery() {
      this.replaceQuery({
        id: null,
        first_name: null,
        last_name: null,
        username: null,
        photo_url: null,
        auth_date: null,
        hash: null,
      })
    }
  },
}

export const tryToAuth = {
  mixins: [
    isAuthorized,
  ],
  methods: {
    async tryToAuth() {
      if (this.isAuthorized) {
        return {ok: true}
      }
      if (!this.$route.query.hash) {
        return {ok: false}
      }

      let {
        id,
        first_name,
        last_name,
        username,
        photo_url,
        auth_date,
        hash,
      } = this.$route.query

      id = Number(id)
      auth_date = Number(auth_date)

      const result = await apiLogin({
        id,
        first_name,
        last_name,
        username,
        photo_url,
        auth_date,
        hash,
      })

      if (result.ok) {
        await this.$store.dispatch('auth/login', result.result.id)
      } else {
        console.log(result)
      }

      return result
    }
  },
}

export const getUserInfo = {
  mixins: [
    isAuthorized,

    languageCode,
  ],
  methods: {
    async getUserInfo() {
      if (!this.isAuthorized) {
        return {ok: false}
      }

      const result = await apiGetUser(this.$store.state.auth.id, this.languageCode)

      if (result.ok) {
        this.$store.commit('auth/setUser', result.result)
      }

      return result
    }
  }
}

export const defaultAuth = {
  mixins: [
    checkAuth,
    tryToAuth,
    removeAuthDataFromQuery,

    isAuthorized,
    authUser,

    getUserInfo,
  ],
  async created() {
    let result = await this.checkAuth()

    if (!result.ok) {
      result = await this.tryToAuth()
    }

    this.removeAuthDataFromQuery()

    if (this.isAuthorized && !this.isUserFetched) {
      result = await this.getUserInfo()
    }
  },
}

export const logout = {
  methods: {
    async logout() {
      const result = await apiLogout()

      if (result.ok) {
        await this.$store.dispatch('auth/logout')
      }
    }
  },
}
